import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledPickerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  @media screen and (max-width: 575px) {
    width: 100%;

    .rdrDateRangePickerWrapper {
      display: block;
    }
  }
`;

export const StyledPicker = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledPickerButton = styled.button`
  position: relative;
  padding: 8px 12px;
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  color: ${themeGet('colors.select.label')};
  background-color: ${themeGet('colors.select.BgColor')};
  border-radius: ${themeGet('radii.base')};
`;

export const StyledPickerPopover = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 11px);
  width: 400px;
  z-index: 3;
  padding: 20px 24px;
  background-color: ${themeGet('colors.body.bg')};
  box-shadow: ${themeGet('shadows.section')};
  border-radius: ${themeGet('radii.base')};

  @media screen and (max-width: 575px) {
    left: 0;
  }
`;

export const StyledOutputDateRange = styled.div`
  display: flex;
  align-items: center;

  > span {
    white-space: nowrap;
    line-height: 16px;
  }

  > .arrow-icon {
    margin-left: 6px;
    margin-right: 6px;
  }

  > .calendar-icon {
    margin-left: 10px;
  }
`;
